const PlusIcon = ({ fill = '#434750' }: { fill?: string }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_676_5410)">
        <path
          d="M12 8.66658H8.66665V11.9999C8.66665 12.3666 8.36665 12.6666 7.99998 12.6666C7.63331 12.6666 7.33331 12.3666 7.33331 11.9999V8.66658H3.99998C3.63331 8.66658 3.33331 8.36658 3.33331 7.99992C3.33331 7.63325 3.63331 7.33325 3.99998 7.33325H7.33331V3.99992C7.33331 3.63325 7.63331 3.33325 7.99998 3.33325C8.36665 3.33325 8.66665 3.63325 8.66665 3.99992V7.33325H12C12.3666 7.33325 12.6666 7.63325 12.6666 7.99992C12.6666 8.36658 12.3666 8.66658 12 8.66658Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_676_5410">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PlusIcon;
